import { getAccessToken } from "@flash-tecnologia/hros-web-utility";
import { QueryClient } from "@tanstack/react-query";
import { createTRPCReact, httpBatchLink } from "@trpc/react-query";
import { inferRouterOutputs } from "@trpc/server";
import type { AppRouter } from "bff";

export type RouterOutput = inferRouterOutputs<AppRouter>;

export const trpc = createTRPCReact<AppRouter>();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: `${process.env.BFF_URL}`,
      headers: async () => {
        const token = await getAccessToken();
        return {
          "x-flash-auth": `Bearer ${token}`,
        };
      },
    }),
  ],
});
